module.exports = __webpack_public_path__ + "img/1472666547.3a5820cb.jpg";